import styled from "styled-components";

export const StyledTutorialWrapper = styled.div`
  background: #121FAA;
  width: 40rem;
  min-height: 5rem;
  gap: ${({ $gap }) => $gap ? $gap : '0.75rem'};
  background: ${({ theme }) => theme.background};
  position: relative;
  overflow: hidden;

  .tutorial-controls {
    border-top:  4px solid #708DF7;
    width: 100%;
    padding: 1.625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;background: 
    linear-gradient(180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );

  }
`;

export const StyledTutorialContent = styled.div`
  position: relative;
  z-index: 2;
`;

export const StyledTutorialBg = styled.div`
    position: absolute;
    top: 1rem;
    right: ${({ rightOffset }) => rightOffset ? rightOffset : '5rem'};
    z-index: 0;
    border-radius: 50%;
    display: inline-block;

    img {
      border-radius: 50%;
      display: block;
      border:1px solid #fff;
    }

    &:after {
      content: "";
      display: block;
      width: 105%;
      height: 105%;
      background: radial-gradient(ellipse at center, rgba(18,31,170,0) 0%,rgba(18,31,170,1) 65%,rgba(18,31,170,1) 100%);
      border-radius: 50%;
      position: absolute;
      top: -2.5%; left: -2.5%;
    }
`;

export const StyledTutorialTitle = styled.div`
  width: 100%;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-size: 2rem;
  font-weight: 800;
  padding:  1.5rem 1.125rem  2rem 1.125rem;
  text-align: ${({ $align }) => $align ? $align : 'left'};
`;

export const StyledTutorialTitleCenter = styled.div`
  width: 100%;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-size: 2rem;
  font-weight: 800;
  padding:  1.5rem 1.125rem  1.375rem 1.125rem;
`;

export const StyledTutorialSubTitle = styled.div`
    width: 100%;
    text-transform: uppercase;
    font-family: ${({$fontType}) => $fontType === 'text' ? 'BebasNeue' : 'NeueMachina'};
    font-size: 1.5rem;
    font-weight: 600;
    padding:  1rem 0  1rem 0;
    text-align: center;
`;

export const StyledTutorialLargeText = styled.div`
    width: 100%;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 1.5rem;
    line-height:2rem;
    font-weight: 600;
    padding: 0 0 1.5rem 0;
    text-align: center;
`;

export const StyledTutorialAchievementArea = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 2rem;
    padding-top: 2rem;

    .none-break {
       white-space: nowrap;
    }

    .media-factor {
      font-family: "NeueMachina";
      font-weight: 600;
      font-size: 1.5rem;
      position: absolute;
      bottom:0;
      right:0;
      color: #253583;

      text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
    }
    .media-factor.media-factor-bottom {
      font-size: 1.25rem;
      right: 0.25rem;
      text-align:center;
    }
    
    .media-item {
      width: 6rem;
      height: 6rem;
      position: relative;
    }

    .media-item-large {
      width: 16rem;
      height: 8rem;
      position: relative;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    img.img-contain {
      object-fit: contain;
    }

    .img-reduced {
      height: 4rem;
      object-fit: contain;
    }

    .media-item-fixed-height {
      height: 8rem;
      width: auto;
      position: relative;
    }
    .media-item-fixed-height img {
      width: auto;
    }
`;
